export default [
    {
        path: 'configuracao',
        component: () => import(
            /* webpackChunkName: 'administracao-configuracao' */
            '@/views/administracao/configuracao/Index'
        ),
        redirect: 'configuracao/index',
        children: [
            {
                name: 'administracao-configuracao-index',
                path: 'index',
                component: () => import(
                    /* weadministracaockChunkName: 'administracao-configuracao-index' */
                    '@/views/administracao/configuracao/Form.vue'
                ),
            },
        ],
    },
]